<template>
  <div>
    <b-overlay
      :show="loading"
      rounded="sm"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
    >
      <div>
        <b-row>
          <b-col cols="12" :lg="8">
            <b-overlay
              :show="loading"
              :variant="`white`"
              :opacity="0.75"
              :blur="``"
              rounded="none"
            >
              <b-card no-body>
                <div class="px-1 pt-1">
                  <h3
                    class="d-flex justify-content-between w-100 border-bottom pb-75 mb-75"
                  >
                    <span>{{ $t('lbl_test_requirement_info') }}</span>
                    <span>#{{ orderDetail.order_code }}</span>
                  </h3>
                </div>

                <div class="px-1 mb-2">
                  <div class="bg-light p-1 rounded-top">
                    <OrderInfomation
                      v-if="Object.keys(orderDetail).length"
                      :orderDetail="orderDetail"
                      @changeStatus="handleChangeStep"
                    />
                  </div>
                  <div
                    class="p-1 rounded-bottom"
                    style="background-color: #ebe9f1"
                  >
                    <b-row>
                      <b-col cols="12" :lg="3">
                        <div class="process-timeline">
                          <div
                            v-for="(node, index) in activities"
                            :key="node.text"
                            class="process-timeline__item d-flex cursor-pointer"
                            @click="changeStep(node)"
                            v-b-tooltip.left
                            :title="
                              $t(
                                isCancelOrder &&
                                  node.text === 'lbl_submit_results'
                                  ? 'lbl_reject_order'
                                  : isPendingOrder && node.index === 1
                                  ? 'lbl_accept_order'
                                  : ''
                              )
                            "
                          >
                            <div
                              class="node"
                              :class="{
                                active: node.isActive,
                                done: activeSteps[index],
                                cancel: isCancelOrder && node.index === 1
                              }"
                            >
                              <div
                                v-if="node.index != 1"
                                class="node-line"
                              ></div>
                            </div>
                            <div class="node-text">{{ $t(node.text) }}</div>
                          </div>
                        </div>
                      </b-col>
                      <b-col cols="12" :lg="9">
                        <div class="h-100">
                          <keep-alive>
                            <Transition name="fade" mode="out-in">
                              <b-col class="order-detail-wrapper">
                                <keep-alive>
                                  <component
                                    :is="activeComponent"
                                    :orderDetail="orderDetail"
                                    class="order-detail-container"
                                    @changeStatus="handleChangeStep"
                                    @uploadConsentForm="handleUploadConsentForm"
                                    @reload="fetchOrderProcessor"
                                  />
                                </keep-alive>
                              </b-col>
                            </Transition>
                          </keep-alive>
                          <div
                            class="rounded bg-white p-1 text-center flex items-center justify-between mt-2"
                            style="gap: 8px"
                          >
                            <b-button
                              class="m-auto"
                              v-if="activeStep.index !== 0"
                              variant="outline-primary"
                              @click="handleClickBackStep"
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.4599 8.28994C11.367 8.19621 11.2564 8.12182 11.1345 8.07105C11.0127 8.02028 10.882 7.99414 10.7499 7.99414C10.6179 7.99414 10.4872 8.02028 10.3654 8.07105C10.2435 8.12182 10.1329 8.19621 10.0399 8.28994L7.03994 11.2899C6.94621 11.3829 6.87182 11.4935 6.82105 11.6154C6.77028 11.7372 6.74414 11.8679 6.74414 11.9999C6.74414 12.132 6.77028 12.2627 6.82105 12.3845C6.87182 12.5064 6.94621 12.617 7.03994 12.7099L10.0399 15.7099C10.1329 15.8037 10.2435 15.8781 10.3654 15.9288C10.4872 15.9796 10.6179 16.0057 10.7499 16.0057C10.882 16.0057 11.0127 15.9796 11.1345 15.9288C11.2564 15.8781 11.367 15.8037 11.4599 15.7099C11.5537 15.617 11.6281 15.5064 11.6788 15.3845C11.7296 15.2627 11.7557 15.132 11.7557 14.9999C11.7557 14.8679 11.7296 14.7372 11.6788 14.6154C11.6281 14.4935 11.5537 14.3829 11.4599 14.2899L9.15994 11.9999L11.4599 9.70994C11.5537 9.61698 11.6281 9.50638 11.6788 9.38452C11.7296 9.26266 11.7557 9.13195 11.7557 8.99994C11.7557 8.86793 11.7296 8.73722 11.6788 8.61536C11.6281 8.4935 11.5537 8.3829 11.4599 8.28994ZM14.6599 11.9999L16.9999 9.70994C17.1882 9.52164 17.294 9.26624 17.294 8.99994C17.294 8.73364 17.1882 8.47824 16.9999 8.28994C16.8116 8.10164 16.5562 7.99585 16.2899 7.99585C16.0236 7.99585 15.7682 8.10164 15.5799 8.28994L12.5799 11.2899C12.4862 11.3829 12.4118 11.4935 12.361 11.6154C12.3103 11.7372 12.2841 11.8679 12.2841 11.9999C12.2841 12.132 12.3103 12.2627 12.361 12.3845C12.4118 12.5064 12.4862 12.617 12.5799 12.7099L15.5799 15.7099C15.6729 15.8037 15.7835 15.8781 15.9054 15.9288C16.0272 15.9796 16.1579 16.0057 16.2899 16.0057C16.422 16.0057 16.5527 15.9796 16.6745 15.9288C16.7964 15.8781 16.907 15.8037 16.9999 15.7099C17.0937 15.617 17.1681 15.5064 17.2188 15.3845C17.2696 15.2627 17.2957 15.132 17.2957 14.9999C17.2957 14.8679 17.2696 14.7372 17.2188 14.6154C17.1681 14.4935 17.0937 14.3829 16.9999 14.2899L14.6599 11.9999Z"
                                  fill="currentColor"
                                />
                              </svg>
                              {{ $t('lbl_previous') }}
                            </b-button>

                            <b-button
                              v-if="
                                !(activeStep.index === 1 ||
                                (activeStep.index === 0 &&
                                  (isCancelOrder || isPendingOrder)))
                              "
                              :class="activeStep.index !== 0 ? 'm-0' : 'm-auto'"
                              variant="primary"
                              @click="handleClickNextStep"
                              v-b-tooltip.left
                              :title="
                                $t(
                                  isCancelOrder && activeStep.index === 0
                                    ? 'lbl_reject_order'
                                    : isPendingOrder && activeStep.index === 0
                                    ? 'lbl_accept_order'
                                    : ''
                                )
                              "
                            >
                              {{ $t('lbl_next') }}
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.4599 8.29002C8.2716 8.09641 8.01409 7.98554 7.74404 7.98179C7.47399 7.97804 7.21351 8.08172 7.0199 8.27002C6.82629 8.45833 6.71542 8.71583 6.71167 8.98588C6.70792 9.25593 6.8116 9.51641 6.9999 9.71002L9.3399 12L6.9999 14.29C6.90617 14.383 6.83178 14.4936 6.78101 14.6154C6.73024 14.7373 6.7041 14.868 6.7041 15C6.7041 15.132 6.73024 15.2627 6.78101 15.3846C6.83178 15.5065 6.90617 15.6171 6.9999 15.71C7.09286 15.8038 7.20346 15.8781 7.32532 15.9289C7.44718 15.9797 7.57789 16.0058 7.7099 16.0058C7.84191 16.0058 7.97262 15.9797 8.09448 15.9289C8.21634 15.8781 8.32694 15.8038 8.4199 15.71L11.4199 12.71C11.5136 12.6171 11.588 12.5065 11.6388 12.3846C11.6896 12.2627 11.7157 12.132 11.7157 12C11.7157 11.868 11.6896 11.7373 11.6388 11.6154C11.588 11.4936 11.5136 11.383 11.4199 11.29L8.4599 8.29002ZM16.9599 11.29L13.9599 8.29002C13.7716 8.10172 13.5162 7.99593 13.2499 7.99593C12.9836 7.99593 12.7282 8.10172 12.5399 8.29002C12.3516 8.47833 12.2458 8.73372 12.2458 9.00002C12.2458 9.26632 12.3516 9.52172 12.5399 9.71002L14.8399 12L12.5399 14.29C12.4462 14.383 12.3718 14.4936 12.321 14.6154C12.2702 14.7373 12.2441 14.868 12.2441 15C12.2441 15.132 12.2702 15.2627 12.321 15.3846C12.3718 15.5065 12.4462 15.6171 12.5399 15.71C12.6329 15.8038 12.7435 15.8781 12.8653 15.9289C12.9872 15.9797 13.1179 16.0058 13.2499 16.0058C13.3819 16.0058 13.5126 15.9797 13.6345 15.9289C13.7563 15.8781 13.8669 15.8038 13.9599 15.71L16.9599 12.71C17.0563 12.6197 17.1338 12.5112 17.1881 12.3908C17.2423 12.2704 17.2721 12.1404 17.2759 12.0084C17.2796 11.8763 17.2571 11.7449 17.2097 11.6216C17.1624 11.4983 17.0911 11.3856 16.9999 11.29H16.9599Z"
                                  fill="white"
                                />
                              </svg>
                            </b-button>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-card>
            </b-overlay>
          </b-col>
          <b-col
            cols="12"
            :lg="4"
            v-if="orderDetail && orderDetail.product_order"
          >
            <b-card no-body>
              <div class="tabs-wrapper">
                <b-tabs fill content-class="mt-2">
                  <b-tab active>
                    <template #title>
                      <div class="w-100" v-b-tooltip.hover :title="$t('lbl_customer_order_info')">
                        <feather-icon icon="UserIcon" size="24" class="mr-0" />
                        <span class="d-none">
                          {{
                          $t("lbl_customer_order_info")
                          }}
                        </span>
                      </div>
                    </template>
                    <OrderReceiverInformation
                      :orderContact="orderDetail.product_order.ContactOrder"
                    />
                  </b-tab>
                  <b-tab>
                    <template #title>
                      <div class="w-100" v-b-tooltip.hover :title="$t('Followers')">
                        <feather-icon icon="BellIcon" size="24" class="mr-0" />
                        <span class="d-none">{{ $t("Followers") }}</span>
                      </div>
                    </template>
                    <OrderFollowerInformation v-if="orderDetail.hasOwnProperty('followers')" :followers="orderDetail.followers" />
                  </b-tab>
                </b-tabs>
              </div>
            </b-card>
            <CommentSection :order="orderDetail" :isProcessor="true" />
          </b-col>
        </b-row>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import OrderInfomation from './Components/OrderInfomation.vue'
import ConsentForm from './Components/ConsentForm.vue'
import Result from './Components/Result.vue'
import OrderReceiverInformation from './Components/OrderReceiverInformation.vue'
import OrderPaymentInformation from './Components/OrderPaymentInformation.vue'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ORDER_FORM_PROCESSOR_STATUS } from '@/utils/constant'
import CommentSection from '@/views/Orders/Detail/Components/CommentSection.vue'
import OrderFollowerInformation from "@/views/Orders/Detail/Components/OrderFollowerInformation.vue";

const DEFAULT_TABS = [
  {
    text: 'lbl_test_register_profile',
    isActive: true,
    component: ConsentForm,
    index: 0
  },
  {
    text: 'lbl_return_the_results',
    isActive: false,
    component: Result,
    index: 1
  }
]

export default {
  components: {
    OrderInfomation,
    ConsentForm,
    OrderReceiverInformation,
    OrderPaymentInformation,
    ToastificationContent,
    CommentSection,
    OrderFollowerInformation
  },
  data() {
    return {
      loading: false,
      orderDetail: {},
      activities: [...DEFAULT_TABS],
      payload: [],
      activeStep: { ...DEFAULT_TABS[0] }
    }
  },
  computed: {
    orderId() {
      return this.$route.params.id
    },
    activeComponent() {
      return this.activities.find((node) => node.isActive)?.component
    },
    activeSteps() {
      const self = this
      const isConsentForm =
        !!self.orderDetail?.concent_form_url ||
        !!self.orderDetail?.order_form_url ||
        !!self.orderDetail?.requisition_form
      const isResult =
        self.orderDetail?.status === ORDER_FORM_PROCESSOR_STATUS.COMPLETE

      return [isConsentForm, isResult]
    },
    isCancelOrder() {
      return (
        this.orderDetail?.status === ORDER_FORM_PROCESSOR_STATUS.CANCEL ||
        this.orderDetail?.status === ORDER_FORM_PROCESSOR_STATUS.SUPPLIER_CANCEL
      )
    },
    isPendingOrder() {
      return this.orderDetail?.status === ORDER_FORM_PROCESSOR_STATUS.PENDING
    }
  },
  watch: {
    $route: {
      deep: true,

      handler() {
        this.fetchOrderProcessor()
      }
    }
  },
  async created() {
    this.activities = [...DEFAULT_TABS].map((item) => ({
      ...item,
      isActive: false
    }))
    const stepInfo = this.activities?.[0]
    stepInfo.isActive = true
    this.activeStep = { ...stepInfo }

    let data = await this.fetchOrdersProcessorById({ id: this.orderId })
    this.orderDetail = { ...data.result?.data }
  },
  methods: {
    ...mapActions('ordersProcessor', ['fetchOrdersProcessorById']),
    changeStep(step) {
      if (
        (this.isCancelOrder || this.isPendingOrder) &&
        step.text === 'Trả kết quả'
      )
        return
      this.activities.find((node) => node.isActive).isActive = false
      step.isActive = true
      this.activeStep = { ...step }
    },
    handleChangeStep(data) {
      this.loading = true
      const params = data.reason
        ? {
            reason: data.reason,
            status: data.status,
            changed_at: Date.now()
          }
        : {
            return_date: data.result_received_date,
            status: data.status,
            changed_at: Date.now()
          }
      store
        .dispatch('ordersProcessor/updateStatusOrderProcessor', {
          params,
          id: data.id
        })
        .then(() => {
          this.fetchOrderProcessor()
          this.loading = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title:
                data?.successTitle ||
                this.$t('lbl_change_status_order_successfully'),
              icon: 'CheckCircleIcon',
              variant: 'success'
            }
          })
        })
        .catch((e) => {
          console.log(e)
          this.loading = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title:
                data?.errorTitle ||
                this.$t('lbl_an_error_occurred_while_updating'),
              icon: 'AlertTriangleIcon',
              variant: 'danger'
            }
          })
        })
    },
    handleUploadConsentForm(url_concent_forms) {
      this.payload = this.payload.map((el, index) => {
        return {
          ...el,
          url_concent_form: url_concent_forms[index]
        }
      })
    },

    async fetchOrderProcessor() {
      let data = await this.fetchOrdersProcessorById({ id: this.orderId })
      this.orderDetail = { ...data.result?.data }
    },
    handleClickBackStep() {
      const step = this.activeStep.index - 1
      const stepInfo = this.activities.find((item) => item.index === step)
      this.changeStep(stepInfo)
    },
    handleClickNextStep() {
      const step = this.activeStep.index + 1
      const stepInfo = this.activities.find((item) => item.index === step)
      this.changeStep(stepInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0px;
}
.title {
  text-align: center;
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 25px;
  span {
    margin-left: 10px;
    font-weight: 400;
    font-size: 15px;
  }
}
.process-timeline {
  &__item {
    align-items: center;
    gap: 20px;
    height: 80px;
    .node {
      width: 28px;
      min-width: 28px;
      height: 28px;
      border-radius: 50%;
      background-color: #6a7580;
      position: relative;
      transition: all 0.3s ease;
      &-text {
        transition: all 0.3s ease;
      }
      &-line {
        position: absolute;
        width: 4px;
        height: 70px;
        background-color: #ced4da;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
      }
      &.active {
        background-color: #476dd6;
        & + .node-text {
          color: #476dd6;
        }
      }
      &.done {
        background-color: #1dca94 !important;
        &::before {
          content: '✓';
          color: white;
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      &.cancel {
        background-color: rgb(243, 22, 22) !important;
        &::before {
          content: 'x';
          color: white;
          display: block;
          position: absolute;
          top: 48%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
    &:hover {
      // zoom: 1.1;
      .node {
        background-color: #476dd6;
        &-text {
          color: #476dd6;
        }
      }
    }
  }
}
.order-detail-wrapper {
  padding: 15px;
  background-color: white;
  border-radius: 4px;
  .order-detail-container {
    ::v-deep .title {
      font-size: 25px;
      font-weight: 400;
      text-align: center;
      margin: 1rem 0 2rem;
    }
    ::v-deep .row {
      margin: 20px 0px;
    }
    ::v-deep .image {
      padding-right: 0px;
      padding-left: 0px;
      width: 80px;
      height: 80px;
    }
  }
}
.tabs-wrapper {
  padding: 15px;
  background-color: white;
  border-radius: 10px;
}
</style>
